import { Component, inject } from '@angular/core';
import { ConfirmService } from '@core/services/confirm.service';
import { ModalComponent } from '@shared/components/modal/modal.component';

@Component({
  selector: 'app-confirm-dialog',
  imports: [ModalComponent],
  host: { '(document:keydown.escape)': 'confirm.current() && confirm.answer(false)' },
  template: `
    @if (confirm.current(); as c) {
      <app-modal [open]="true" [title]="c.title" (closed)="confirm.answer(false)">
        <p class="text-sm text-gray-600">{{ c.message }}</p>
        <div class="flex justify-end gap-2 mt-5">
          <button type="button" (click)="confirm.answer(false)" class="rounded-lg border border-gray-300 text-gray-700 font-semibold px-4 py-2 text-sm hover:bg-gray-50">
            {{ c.cancelText || 'Volver' }}
          </button>
          <button
            type="button"
            (click)="confirm.answer(true)"
            class="rounded-lg text-white font-semibold px-4 py-2 text-sm"
            [class]="c.danger ? 'bg-red-600 hover:bg-red-700' : 'bg-primary-600 hover:bg-primary-700'"
          >
            {{ c.confirmText || 'Confirmar' }}
          </button>
        </div>
      </app-modal>
    }
  `,
})
export class ConfirmDialogComponent {
  confirm = inject(ConfirmService);
}
